/**
 * Pac-Man by Oscar Wallhult
 */
import Game from './game';

window.addEventListener('DOMContentLoaded', () => {
  new Game('#gameContainer', 1024, 592);
});
